import { render, staticRenderFns } from "./BasicText.vue?vue&type=template&id=f8d50068&"
import script from "./BasicText.vue?vue&type=script&lang=js&"
export * from "./BasicText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports